import { render, staticRenderFns } from "./TagPrint.vue?vue&type=template&id=54447942&scoped=true"
import script from "./TagPrint.vue?vue&type=script&lang=js"
export * from "./TagPrint.vue?vue&type=script&lang=js"
import style0 from "./TagPrint.vue?vue&type=style&index=0&id=54447942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54447942",
  null
  
)

export default component.exports